export default "__VITE_ASSET__10283285__"